// ============================================================
//  VistaTech Student Tracker — Configuration
//
//  SECURITY NOTE:
//  SHARED_SECRET will be visible in the compiled JS bundle.
//  This is acceptable for a small internal tool — treat the
//  Web App URL + secret as semi-private and only share the
//  app with mentors and admin. NEVER commit real values here;
//  fill them in after deploying the Apps Script Web App.
//
//  Add this file to .gitignore if it contains real secrets:
//    echo "src/tracker/config.ts" >> .gitignore
// ============================================================

export const WEB_APP_URL = 'https://vistatech-serversss-production.up.railway.app/api'

export const SHARED_SECRET = 'vt-tracker-secret-2024';
